module.exports = __webpack_public_path__ + "static/media/homem_r2_c4.9f9b7ab5.jpg";